import React, { Component } from 'react'
import { Card, Input, Button, Row, Col } from "reactstrap"
import '../del.css';
import CreatableSelect from 'react-select/creatable';
import axios from "axios";
import Loading from './Loading';


class Upload extends Component {
    state = {
        images: [],
        url: "https://i.imgur.com/lu3Afp3.png",
        files: [],
        groups: [],
        selectedGroup:{},
        texti: "",
        loading: false
    }
    
    fileUpload = async (file, grp) => {
        console.log(file);
        const url = 'https://azure.ratemycourse.review/upload/';
        const formData = new FormData();
        formData.append('file',file)
        formData.append('token',localStorage.getItem("token"))
        formData.append('group_id',grp)
        formData.append('local_url', "dghfdsgdsgfgsdg")
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        return await axios.post(url,formData,config)
  }
    addImage = (e) => {
        if (e.clipboardData.items[0].type === "image/png") {
            let image = URL.createObjectURL(e.clipboardData.items[0].getAsFile());
            let newImages = this.state.images.concat(image);
            this.setState({ images: newImages });
        }
    }
    deleteImage = (image) => {
        let newImages = this.state.images.filter(im => im !== image);
        this.setState({ images: newImages });
    }
    hideBg = () => {
        this.setState({ url: "" });
    }
    showBg = () => {
        this.setState({ url: "https://i.imgur.com/lu3Afp3.png" });
    }

    onFileChange = (event) => {
        this.setState({ files: Array.from(event.target.files) });
    }

    

    handleChange = (newValue, actionMeta) => {
        this.setState({selectedGroup: newValue})
    };
    handleInputChange = (e) =>{
        this.setState({[e.target.name]: e.target.value})
    }
    componentDidMount() {
        const auth = {
            user_id: localStorage.getItem("token")
        };
        if (localStorage.getItem("token") !== null) {
            axios.post("https://azure.ratemycourse.review/groups/", auth)
                .then(res => {
                    let options = []
                    res.data.map((group)=>options.push({value:group._id, label: group.group_name}))
                    this.setState({groups: options, selectedGroup: options[0]});
                })
        }
    }
    setLoad = (e) =>{
        this.props.load();
        this.bombsAway()
    }
    bombsAway = async() => {
        console.log("adsad")
        if (this.state.selectedGroup.hasOwnProperty('__isNew__')){
            let newGroup = {
                user_id:localStorage.getItem("token"),
                group_name: this.state.selectedGroup.value
            }
            let newGroupRes = await axios.post("https://azure.ratemycourse.review/group/new", newGroup);
            if (newGroupRes.status === 201 ){
                this.fullsend(newGroupRes.data.group_id);
            }
            else{
                this.setState({loading:false});
            }
        }else{
            this.fullsend(this.state.selectedGroup.value);
        }
        this.setState({loading: false});
        
    }
    fullsend = async(grpid) =>{
        if(this.state.files.length > 0){
            let result = await this.fileUpload(this.state.files[0], grpid);
            console.log(result);
            this.props.reload();
        }
        if(this.state.images.length > 0){
            let blob = await fetch(this.state.images[0]).then(r => r.blob());
            let result = await this.fileUpload(blob, grpid);
            console.log(result);
            this.props.reload();
        }
        if(this.state.texti !== ""){
            let textBody = {}
            if (this.validURL(this.state.texti)){
                if(this.matchYoutubeUrl(this.state.texti)){
                     textBody = {
                        text: "",
                        url: this.state.texti,
                        token: localStorage.getItem("token"),
                        group_id: grpid,
                        content_type: "youtube"
                    }
                }else {
                     textBody = {
                        text: "",
                        url: this.state.texti,
                        token: localStorage.getItem("token"),
                        group_id: grpid,
                        content_type: "website"
                    }
                }   
            }else {
                textBody = {
                    text: this.state.texti,
                    url: "",
                    token: localStorage.getItem("token"),
                    group_id: grpid,
                    content_type: "text"
                }
            }
            let result = await axios.post("https://azure.ratemycourse.review/upload_url/", textBody);
            this.setState({loading: false});
            console.log(result);
           
            if (result.status === 201){
                this.props.reload();
            }
        }
    }
    validURL = (str) => {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
      }
    matchYoutubeUrl = (url) => {
        var p = new RegExp("^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+");
        return !!p.test(url);
    }
    render() {
        return (
            <div>
            {this.state.loading? <Loading /> : <Card className="shadow-sm">
                <Row className="ml-2">
                    {this.state.images.map((image, i) => (
                        <div className="img-wraps" key={i}>
                            <span className="closes" title="Delete" onClick={(e) => this.deleteImage(image)}>&times;</span>
                            <img className="p-2" length="100" width="100" src={image} key={i} alt={`Pasted: ${image}`} />
                        </div>
                    ))}

                    {this.state.files.map((file, i) => (
                        <div key={i} className="p-2">
                            {file.name}
                        </div>
                    ))}


                </Row>

                <Input
                    type="textarea"
                    name="texti"
                    id="upload"
                    style={{ borderWidth: "0px", border: "none", backgroundImage: `url(${this.state.url})` }}
                    onPaste={(e) => this.addImage(e)}
                    onFocus={this.hideBg}
                    onBlur={this.showBg}
                    onChange={this.handleInputChange}
                    value={this.state.texti}
                />

                <Row className="mr-2 mb-3">
                    <Col md="4" className="mt-2 pl-4">
                        <input type="file" onChange={this.onFileChange} multiple />
                    </Col>
                    <Col md="5"></Col>
                    <Col md="2">
                        <CreatableSelect
                            isClearable
                            onChange={this.handleChange}
                            defaultValue={this.state.selectedGroup}
                            options={this.state.groups}
                        />
                    </Col>
                    <Col md="1" className="align-items-end">
                    <Button className="" onClick={this.setLoad} style={{backgroundColor: "#6056A0"}}>Upload</Button>
                    </Col>
                </Row>
            </Card>}
            </div>
        )
    }
}
export default Upload;